import { Route, Redirect } from 'react-router-dom';
import Addresses from '../pages/addresses/Addresses';

const AddressesRoute = ({ isLogged, ...rest }) => (
	<Route
		{...rest}
		render={(props) =>
			isLogged ? (
				<Addresses />
			) : (
				<Redirect
					exact
					to={{
						pathname: '/',
						state: {
							from: props.location,
						},
					}}
				/>
			)
		}
	/>
);

export default AddressesRoute;
